import { createFileRoute, Outlet } from '@tanstack/react-router';

// Layout for /customers/:id/* — hosts the view (index) and edit child routes.
export const Route = createFileRoute('/_authenticated/customers/$id')({
  component: () => <Outlet />,
});
